var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-2 border border-primary",attrs:{"title":"Plano de Contas","tag":"article"}},[(_vm.isLoading)?_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary"}}),_c('p',[_vm._v("Carregando...")])],1):_c('div',[_c('Tree',{attrs:{"treeData":_vm.treeData}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }